/**
 * MBURCANDLECO Homepage JavaScript
 * Scroll reveal animations and interactive elements
 * 
 * Add this to your theme's assets folder
 * Then include in theme.liquid before </body>: 
 * {{ 'homepage-sections.js' | asset_url | script_tag }}
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // SCROLL REVEAL ANIMATION
  // ============================================
  const revealElements = document.querySelectorAll('.hp-reveal');
  
  const revealObserverOptions = {
    root: null,
    rootMargin: '0px 0px -100px 0px',
    threshold: 0.1
  };
  
  const revealObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target);
      }
    });
  }, revealObserverOptions);
  
  revealElements.forEach(element => {
    revealObserver.observe(element);
  });
  
  // ============================================
  // PRODUCT CAROUSEL
  // ============================================
  const carousel = document.querySelector('[data-carousel]');
  const prevBtn = document.querySelector('[data-carousel-prev]');
  const nextBtn = document.querySelector('[data-carousel-next]');
  
  if (carousel && prevBtn && nextBtn) {
    const scrollAmount = 320; // Width of one card + gap
    
    prevBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    
    nextBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    
    // Touch/swipe support for mobile
    let isDown = false;
    let startX;
    let scrollLeft;
    
    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      carousel.style.cursor = 'grabbing';
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    
    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    
    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    
    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });
  }
  
  // ============================================
  // GIFT BUNDLE OPTION SELECTOR
  // ============================================
  const giftOptions = document.querySelectorAll('.hp-gift-option');
  
  giftOptions.forEach(option => {
    option.addEventListener('click', function() {
      giftOptions.forEach(o => o.classList.remove('active'));
      this.classList.add('active');
    });
  });
  
  // ============================================
  // FLOATING SAMPLE BUTTON
  // ============================================
  const floatingBtn = document.getElementById('floating-sample');
  
  if (floatingBtn) {
    const scrollThreshold = parseInt(floatingBtn.dataset.threshold) || 600;
    
    window.addEventListener('scroll', function() {
      if (window.scrollY > scrollThreshold) {
        floatingBtn.classList.add('visible');
      } else {
        floatingBtn.classList.remove('visible');
      }
    }, { passive: true });
  }
  
  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerOffset = 80;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  
  // ============================================
  // QUICK ADD TO CART (AJAX)
  // ============================================
  const quickAddForms = document.querySelectorAll('.hp-product-quick-add form');
  
  quickAddForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const button = this.querySelector('button');
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      
      const formData = new FormData(this);
      formData.append('quantity', 1);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
        
        // Update cart count if your theme has a cart counter
        if (typeof window.updateCartCount === 'function') {
          window.updateCartCount();
        }
        
        // Trigger cart drawer if your theme has one
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
      })
      .catch(error => {
        console.error('Error:', error);
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
    });
  });
  
  // ============================================
  // PARALLAX EFFECT FOR HERO (Optional)
  // ============================================
  const heroSection = document.querySelector('.hp-hero');
  
  if (heroSection && window.innerWidth > 768) {
    const floats = heroSection.querySelectorAll('.hp-hero-float');
    
    window.addEventListener('scroll', function() {
      const scrolled = window.pageYOffset;
      const rate = scrolled * 0.3;
      
      floats.forEach((float, index) => {
        const direction = index % 2 === 0 ? 1 : -1;
        float.style.transform = `translateY(${rate * direction * 0.5}px)`;
      });
    }, { passive: true });
  }
  
  // ============================================
  // LAZY LOAD IMAGES
  // ============================================
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  }
  
});
